<style lang="scss" src="./SolicitudesHistoricasTable.scss"></style>
<template src="./SolicitudesHistoricasTable.html"></template>

<script>
import {Divider, Pagination, Table, TableColumn, Tag, Tooltip} from 'element-ui';
import {requestSolicitudMixin} from "@/api/solicitudPH";
import ScreenSizeMixin from "@/mixins/ScreenSizeMixin";
import {NotifyMixin} from "@/mixins/NotifyMixin";
import moment from "moment";
import {TableMixin} from "@/mixins/TableMixin";
import {utils} from "@/utils";
import ToolbarSearch from "@/components/Shared/ToolbarSearch/ToolbarSearch";

export default {
  name: "SolicitudesHistoricasTable",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Tooltip.name]: Tooltip,
    [Pagination.name]: Pagination,
    [Divider.name]: Divider,
    [Tag.name]: Tag,
    ToolbarSearch,
  },
  mixins: [
    requestSolicitudMixin,
    ScreenSizeMixin,
    NotifyMixin,
    TableMixin
  ],
  data() {
    return {
      pickerOptFilterDate: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      listSelection: [],
      isSelect: false,
    }
  },
  beforeMount() {
    const pagingQuery = {
      currentPage: this.pagination.currentPage,
      pageSize: this.pagination.pageSize,
    }
    this.getList(pagingQuery, true);
  },
  methods: {
    getList(pagingQuery = {}, firstTime = false) {
      this.loading = true
      pagingQuery['compress'] = false
      this.getListaSolicitud(pagingQuery)
        .then(response => {
          this.$log.debug('getListaSolicitud', response.data.statusCode)

          if (response.data.statusCode === 200) {
            this.pagination.total = response.data.totalItems || 5
            const data = JSON.parse(response.data.datos)

            this.tableData = data.map(row => {
              row.run = utils.rutFilter(row.run)
              row.solicitud_fecha_ingreso = moment.utc(row.solicitud_fecha_ingreso)
                .local().format('DD-MM-YYYY HH:mm')
              return row
            })

            this.$log.debug(this.tableData)

            this.errored = false;
            if (this.tableData.length === 0) {
              if (firstTime) {
                this.showError('No hay solicitudes históricas, puede presionar el botón refrescar si lo desea.')
              } else {
                this.showWarn('No hay solicitudes históricas con sus filtros, puede presionar el botón refrescar si lo desea.')
              }
            }
            this.$scrollTo('#solicituHistoricaTable')
          } else {
            this.errored = true
            this.showError('Ocurrió un error inesperado al cargar los datos')
          }
        })
        .catch(err => {
          this.$log.fatal('getListaSolicitud', err, err.response, err.request)
          this.errored = true
          this.showError('Ocurrió un error inesperado al cargar los datos')
        })
        .finally(() => {
          this.loading = false
        })
    },
    viewItem(id) {
      this.$log.debug('viewItem', id)
      this.$emit('on-view', id)
    }
  },
  computed: {
    perPage() {
      if (this.parametro.params)
        return parseInt(this.parametro.params.paginacion)
      return 10
    },
  },
}
</script>
